import React, { useState, useContext, useRef, useEffect} from "react";

import {View, Text, Image, BackHandler}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import cores from '../util/cores'

import {estilos} from '../util/estilos'

import * as util from '../util/util'

import * as numeros from '../util/numeros'

import * as data from '../util/data'

import * as texto from '../util/texto'

import * as validacao from '../util/validacao'

import {buscarUsuario as wsBuscarUsuario, verificarEmail as wsVerificarEmail,  verificarTel as wsVerificarTel, 
	enviarCodigoVerificacaoTel as wsEnviarCodigoVerificacaoTel, alterarUsuario as wsAlterarUsuario} from '../ws/ws_usuarios'

import {buscarImagemUsuario as wsBuscarImagemUsuario} from '../ws/ws_imagem_usuario'

import contexto from '../util/contexto'

import Botao from '../componentes/Botao'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import { useFocusEffect } from '@react-navigation/native';

import {MaskedTextInput} from "react-native-mask-text";

import {carregamento} from '../componentes/Carregamento'

import FormularioUsuario from '../componentes/FormularioUsuario'

import {USER_TIPO_PF, TELA_PRINCIPAL} from '../util/constantes'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'

import Imagem from '../componentes/Imagem'

import Alerta from '../componentes/Alerta'

import {salvarImagemUsuario} from '../ws/ws_imagem_usuario'

import Upload from '../componentes/Upload'




export default function TelaDetalheUsuario(){
    
	const {valorContexto} = useContext(contexto);

	const [sincronizando, setSincronizando] = useState(true)  

	const [imagem, setImagem] = useState()

    const navegacao = new useNavigation();

	const [usuario, setUsuario] = useState()

	const [editando, setEditando] = useState(false)

	const btVerificarEmailRef  = useRef(null)
	const btVerificarTelRef  = useRef(null)
	const btEnviarVerificacaoTelRef  = useRef(null)
	
	const [codigoVerificacaoTel, setCodigoVerificacaoTel] = useState(null)
	const [verificandoTel, setVerificandoTel] = useState(false)
   
	const formularioUsuarioRef  = useRef(null)
   
	const blockBackRef = useRef(false);
  
	
  
	const buscarDados= async ()=>{
		
		setSincronizando(true);
		
		await buscarUsuario();
	
		await buscarImagemUsuario();
		
		setSincronizando(false)
	}


	const voltar = () => {
			
		util.print("voltar");
	
		if(blockBackRef.current == true){
			
			util.print("voltar editando");
			
			setEditando(false);
			
			blockBackRef.current = false;
		}
		else
			navegacao.replace(util.processaVoltar());
		
		return true;
	};


	useFocusEffect(React.useCallback(() => {
		
		util.print("TelaDetalheUsuario");
		
		BackHandler.addEventListener('hardwareBackPress', voltar);
		
		buscarDados()
		
		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};
		
	}, []));
   
   
	const buscarImagemUsuario= async ()=>{

		let aux  = await wsBuscarImagemUsuario(valorContexto.idUsuarioAtual);
		
		setImagem(aux!=null && util.temConteudo(aux.imagem)?aux.imagem:null);
	}


	const buscarUsuario= async ()=>{
		
		util.print("buscarUsuario - remoto -"+valorContexto.idUsuarioAtual)
		
		setUsuario(null);
		
		let aux  = await wsBuscarUsuario(valorContexto.idUsuarioAtual);
   
		if(util.temConteudo(aux))
			setUsuario(aux);
	}
	
   
	const verificarTel= async ()=>{
	
		btVerificarTelRef.current.setCarregando(true)
	
		let aux = await wsVerificarTel(valorContexto.idUsuarioAtual);
		
		if(aux!=null){
		
			btVerificarTelRef.current.setCarregando(false);
		
			setVerificandoTel(true);
		
			setCodigoVerificacaoTel(null);
		}
		else{
			
			util.alertaErroGenerico();
			
			btVerificarTelRef.current.setCarregando(false);
		}
	}
   
   
	const enviarCodigoVerificacaoTel= async ()=>{
	
		btEnviarVerificacaoTelRef.current.setCarregando(true)
	
		if(texto.isBlanck(codigoVerificacaoTel)){

            Alerta("Atenção", 'Informe o Código de verificação.');
			btEnviarVerificacaoTelRef.current.setCarregando(false);
            return;
        } 
		
		let aux = await wsEnviarCodigoVerificacaoTel(codigoVerificacaoTel);
		
		if(aux!=null){
		
			btEnviarVerificacaoTelRef.current.setCarregando(false);
		
			setVerificandoTel(false);
		
			setCodigoVerificacaoTel(null);
			
			await buscarDados();
		}
		else{
			
			Alerta("Atenção", 'Código de verificação inválido.');
			
			btEnviarVerificacaoTelRef.current.setCarregando(false);
		}	
	}
   
   
	const verificarEmail= async ()=>{
	
		btVerificarEmailRef.current.setCarregando(true)

		let aux = await wsVerificarEmail(valorContexto.idUsuarioAtual);
		
		if(aux!=null)
			Alerta("Enviado", 'Um E-mail de verificação foi enviado pra seu endereço de E-mail.');
		else
			util.alertaErroGenerico();
		
		btVerificarEmailRef.current.setCarregando(false)
	}
   
   
	const prepararFormulario= async ()=>{
	
		if(editando && usuario!=null)	
			formularioUsuarioRef.current.setDados(usuario.tipo, 
													usuario.tipo == USER_TIPO_PF? usuario.cpf_cnpj:null, 
														usuario.tipo == USER_TIPO_PF? null:usuario.cpf_cnpj, 
														util.temConteudo(usuario.nascimento)?
														numeros.formatarSomenteNum(data.converteDataEuaParaBr(usuario.nascimento)):null, 
															usuario.nome_completo, 
																usuario.email, 
																	usuario.tel, 
																		usuario.senha);
	}
	
	
	const enviarImagem= async (arquivo)=>{
	
		await salvarImagemUsuario(valorContexto.idUsuarioAtual, arquivo);
		
		await buscarImagemUsuario();
	};


	useEffect(() => {prepararFormulario()}, [editando]);
   
	
	async function salvar(dados){
		
		dados['id'] = valorContexto.idUsuarioAtual;
		
         let usuario  = await wsAlterarUsuario(dados)

        if(usuario == null || usuario.id ==null){
             
			formularioUsuarioRef.current.salvarErro(usuario.mensagem);
            return;
        }

        formularioUsuarioRef.current.salvarSucesso();
		
		setEditando(false);
		
		await buscarDados();
    }
  
	return (
		<ViewDegradeVertical titulo="Meus dados Cadastrais" voltar={()=>voltar()}>  
			{ (sincronizando) ?
				(carregamento(sincronizando)):
				(<Scroll> 
					{(editando)?
						(<Bloco todaArea={true}>          
							<FormularioUsuario ref={formularioUsuarioRef} salvar={salvar} editarSenha={false}/>
						</Bloco>):
						(formularioVisualizar())
					}
				</Scroll>)	
			} 		
        </ViewDegradeVertical>)
	
	
	function formularioVisualizar(){
		return(
			<View>
				<Bloco>  
					<View style={{marginTop:10}}/>  
					<View style={{alignItems:'center'}}>
						<Text style={estilos.rotulo_titulo}>Foto de Perfil</Text>	    
					</View>
					
					<View style={{alignItems:'center'}}>
						<Imagem imagem={imagem} tamanho={150}/>
						{imagem==null && <Text style={estilos.rotulo_padrao}>Você ainda não envio sua foto</Text>}
					</View> 
					
					<View style={{marginTop:20}}/>   	
					
					<View style={{alignItems:'center'}}>
						<Upload acaoRecebimentoArquivo={(arquivo)=>enviarImagem(arquivo)}/>
					</View>
					<View style={{marginTop:10}}/>  
				</Bloco>
				
				<Bloco> 	
			
					<View style={{marginTop:10}}/>  
					
					<View style={{alignItems:'center'}}>
						<Text style={estilos.rotulo_titulo}>Dados Pessoais</Text>	    
					</View>
					
					<View style={{marginTop:20}}/> 
					
					<View style={estilos.grade}>
						<View style={estilos.coluna}> 
							<Text style={estilos.rotulo_titulo}>Nome:</Text>
						</View>
						<View style={estilos.coluna_dupla}> 
							<Text style={estilos.rotulo_padrao}>{usuario.nome_completo}</Text>
						</View>
					</View>
					
					<View style={{marginTop:10}}/> 
					
					<View style={estilos.grade}>
						<View style={estilos.coluna}> 
							<Text style={estilos.rotulo_titulo}>Tipo:</Text>
						</View>
						<View style={estilos.coluna_dupla}> 
							<Text style={estilos.rotulo_padrao}>{usuario.tipo==USER_TIPO_PF?'Pessoal Física':'Pessoal Jurídica'}</Text>
						</View>
					</View>
					
					<View style={{marginTop:10}}/> 
						
					<View style={estilos.grade}>
						<View style={estilos.coluna}> 
							<Text style={estilos.rotulo_titulo}>{usuario.tipo==USER_TIPO_PF?'CPF':'CNPJ'}:</Text>
						</View>
						<View style={estilos.coluna_dupla}> 
							<Text style={estilos.rotulo_padrao}>{validacao.formataCnpjCpf(usuario.cpf_cnpj)}</Text>
						</View>
					</View>

					<View style={{marginTop:10}}/> 
						
					<View style={estilos.grade}>
						<View style={estilos.coluna}> 
							<Text style={estilos.rotulo_titulo}>Nascimento:</Text>
						</View>
						<View style={estilos.coluna_dupla}> 
							<Text style={estilos.rotulo_padrao}>{usuario.tipo==USER_TIPO_PF?data.converteDataEuaParaBr(usuario.nascimento):'-'}</Text>
						</View>
					</View>
					
					<View style={{marginTop:30}}/>
					
					<View style={estilos.grade}>
						<View style={estilos.coluna}/> 
						<View style={[estilos.coluna_dupla, {alignItems:'center'}]}>
							<Botao 
								acao={()=>{
									
									setEditando(true)
									
									blockBackRef.current = true
								}}
								texto="Atualizar Cadastro"/>    
						</View>
						<View style={estilos.coluna}/> 
					</View> 
					<View style={{marginTop:10}}/>  
				</Bloco> 
				
				<Bloco> 	
					<View style={{marginTop:10}}/>  
					<View style={{alignItems:'center'}}>
						<Text style={estilos.rotulo_titulo}>Dados de Contato</Text>	    
					</View>
				
					<View style={{marginTop:20}}/> 
				
					<View style={estilos.grade}>
						<View style={estilos.coluna}> 					
							<Text style={estilos.rotulo_titulo}>Email:</Text>
						</View>
						<View style={estilos.coluna_dupla}> 					
							<Text style={estilos.rotulo_padrao}>{usuario.email}</Text>
						</View>
						<View style={[estilos.coluna, {alignItems:'flex-end'}]}> 
							{(usuario.email_confirmado<=0)?
								(<Image source={require("../imgs/atencao.png")} style={{height: 25, width: 25, margin:10}}/>):
								(<Image source={require("../imgs/checado.png")} style={{height: 25, width: 25, margin:10}}/>)
							}
						</View>
					</View>

					{ usuario.email_confirmado<=0 && 
						<View>
							<View style={{marginTop:10}}/> 
							<View style={{alignItems:'center'}}> 
								<Text style={[estilos.rotulo_padrao, {marginTop:10, color: cores.vermelho}]}>E-mail ainda não verificado!</Text>
							</View>
							<View style={{marginTop:10}}/> 
							<View style={{alignItems:'center'}}> 
								<Botao
									acao={()=>verificarEmail()}
									texto="Verificar"
									somente_texto={true}
									ref={btVerificarEmailRef}/>   
							</View>
						</View>
					}
					
					<View style={{marginTop:30}}/> 
						
					{(!verificandoTel)? 
						(<View>
							<View style={estilos.grade}>
								<View style={estilos.coluna}> 					
									<Text style={estilos.rotulo_titulo}>Fone:</Text>
								</View>
								<View style={estilos.coluna_dupla}> 					
									<Text style={estilos.rotulo_padrao}>{validacao.formataFone(usuario.tel)}</Text>
								</View>
								<View style={[estilos.coluna, {alignItems:'flex-end'}]}> 
									{(usuario.tel_confirmado<=0)?
										(<Image source={require("../imgs/atencao.png")} style={{height: 25, width: 25, margin:10}}/>):
										(<Image source={require("../imgs/checado.png")} style={{height: 25, width: 25, margin:10}}/>)
									}
								</View>
							</View>
							
							{usuario.tel_confirmado<=0 && 
								<View>
									<View style={{marginTop:10}}/> 
									<View style={{alignItems:'center'}}> 
										<Text style={[estilos.rotulo_padrao, {marginTop:10, color: cores.vermelho}]}>Telefone ainda não verificado!</Text>
									</View>
									<View style={{marginTop:10}}/> 
									<View style={{alignItems:'center'}}> 
										<Botao
											acao={()=>verificarTel()}
											texto="Verificar"
											somente_texto={true}
											ref={btVerificarTelRef}/>   
									</View>
								</View>
							}
						</View>):	
						(<View>
							<View style={{marginTop:20}}/> 				
								
							<View style={{alignItems:'center'}}> 
								<Text style={estilos.rotulo_padrao}>Informe o código de verificação enviado por SMS:</Text>
								
								<MaskedTextInput  
									placeholder="" 
									mask="999999"
									style={[estilos.campo_padrao, {width: '50%'}]} 
									onChangeText={(text, rawText)=>setCodigoVerificacaoTel(rawText === ''?null:rawText)}
									keyboardType="numeric"
									value={codigoVerificacaoTel}/>
							</View>
							<View style={{marginTop:10}}/> 
							<View style={{alignItems:'center'}}> 
								<Botao 
									acao={()=>enviarCodigoVerificacaoTel()}
									texto="Validar Código"
									ref={btEnviarVerificacaoTelRef}/>
							</View>
						</View>)
					}
					<View style={{marginTop:10}}/> 	
				</Bloco>
			</View> 
		)
	}
}